import { render, staticRenderFns } from "./AdminStudyGroupEdit.vue?vue&type=template&id=43adcbe6&"
import script from "./AdminStudyGroupEdit.vue?vue&type=script&lang=js&"
export * from "./AdminStudyGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports